"use client";

import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

export function Switch({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "relative inline-flex h-[18px] w-8 flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "bg-[#DCDFE3] data-[state=checked]:bg-[#4CAF50]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4CAF50]/40",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none mt-[2px] inline-block h-[14px] w-[14px] rounded-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.15)] transition-transform duration-200",
          "translate-x-[2px] data-[state=checked]:translate-x-[14px]",
        )}
      />
    </SwitchPrimitive.Root>
  );
}
